import MapPin from '@assets/icons/map-pin.svg';
import React from 'react';
import { MapMarkerProps } from './types';
import { OverlayView } from '@react-google-maps/api';
import { StyleSheet, View } from 'react-native';
import { TouchableOpacity } from '@gorhom/bottom-sheet';
import { useTheme } from '@/contexts/theme-context';

const PIN_SIZE = 32;

export const MapMarker: React.FC<MapMarkerProps> = ({
  coordinate,
  fill,
  onPress,
}) => {
  const theme = useTheme();

  return (
    <OverlayView
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      position={{
        lat: coordinate.latitude,
        lng: coordinate.longitude,
      }}
    >
      <View style={styles.mapPinContainer}>
        <TouchableOpacity onPress={onPress}>
          <MapPin
            fill={fill || theme.colors.accent}
            height={PIN_SIZE}
            width={PIN_SIZE}
          />
        </TouchableOpacity>
      </View>
    </OverlayView>
  );
};

const styles = StyleSheet.create({
  // The pin is rendered at (0, 0) with a height and width of 32,
  // which puts the "pointer" of the pin at (16, 32), so we use
  // these negative margins to offset it
  mapPinContainer: {
    marginLeft: (PIN_SIZE / 2) * -1,
    marginTop: PIN_SIZE * -1,
  },
});
